import { CoreIcon } from '../core-icon';
import streetViewColorSVG from '../../assets/icons/street-view-color.svg';
import type { IconProps } from '../core-icon';

export const StreetViewColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={streetViewColorSVG} {...props} />;
};
